import { enumPropsFactoryProvider, objectToEnumMap } from './enum-helper';
import color from './color';

/**
 * Тип фрейма контейнера
 * @type {Object}
 */
export var FRAME_STYLE = {
    border: 'border',
    shadow: 'shadow',
    onlyRoundCorners: 'only_round_corners'
};

var AVAILABLE_FRAME_STYLE = objectToEnumMap(FRAME_STYLE);
var frameStyleFactory = enumPropsFactoryProvider(AVAILABLE_FRAME_STYLE, FRAME_STYLE.onlyRoundCorners);

/**
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-container-block.json
 * @param {String} frame.style
 * @param {String} frame.color
 * @param {String} defaultStyle
 * @param {String} defaultColor
 * @return {Frame}
 */
export default (function (frame) {
    var defaultStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var defaultColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    if (!frame) {
        return {
            style: '',
            color: ''
        };
    }

    return {
        style: frameStyleFactory(frame.style, defaultStyle),
        color: color(frame.color, defaultColor)
    };
});